module.exports = "https://www.gc-pro.gnp.com.mx/8a91d558a8cec4a86d55ca3114555423.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-1.png
// module id = 937
// module chunks = 0 1